module.exports = __webpack_public_path__ + "static/media/card_03.f9e9a725.png";